// @flow
import React from 'react';
import { connect } from 'react-redux';
import { MdMoreVert, MdEdit, MdDelete /* , MdGroupAdd */ } from 'react-icons/lib/md';
import i18n from 'i18n-js';

import type { ID_TYPE } from '../../types/common';
// import type { ROUTE_STOP_TYPE } from '../../types/routes';
import type { STUDENT_TYPE } from '../../types/student';
import { addMeta } from '../../actions/common';
import * as selectors from '../../reducers';
import * as routesActions from '../../actions/routes';
import * as closeableActions from '../../actions/closeable';
import Button from '../Button';
import OmnisearchLoadingResults from '../OmnisearchLoadingResults';
import Card from '../Card';
import CardFooter from '../CardFooter';
import CardHeader from '../CardHeader';
import CardContent from '../CardContent';
import CardHeaderRightGroup from '../CardHeaderRightGroup';
import CardHeaderTitleContainer from '../CardHeaderTitleContainer';
import CardHeaderTitle from '../CardHeaderTitle';
import PopMenu from '../PopMenu';
import RouteCardPassengers from '../RouteCardPassengers';
import StudentSearch from '../StudentSearch';

import styles from './stopCard.css';
import Popup from '../Popup';
import RouteStopEditPopupContainer from '../RouteStopEditPopupContainer';
import { Delete, Search } from '../CommonTexts';


type StopCardPropTypes = {
  id: ID_TYPE,
  name: string,
  students: Array<STUDENT_TYPE>,
  isLoading?: boolean,
  isShowing?: boolean,
  onStudentSelected?: Object => mixed,
  isMapPristine?: boolean,
};

const RouteStopOptionsDummy = ({ onEdit, onDelete }: { onEdit: Function, onDelete: Function }) => (
  <PopMenu
    id="routeStopOptionsPopover"
    isRound
    options={[
      {
        Icon: MdEdit,
        title: i18n.t('buttons.edit'),
        onClick: onEdit,
      },
      {
        Icon: MdDelete,
        title: Delete(),
        tint: 'error',
        onClick: onDelete,
      },
    ]}
  >
    <Button
      size="medium"
      Icon={MdMoreVert}
      iconPosition="right"
      tint="mediumGray"
      clearMargins
      isTransparent
      isOutlined
    />
  </PopMenu>
);

const RouteStopOptions = connect(
  (state, { id }) => ({
    route: selectors.getRoute(state, selectors.getRouteStop(state, id).route),
  }),
  (dispatch, { id }) => ({
    onEdit() {
      dispatch(closeableActions.open('editRouteStop'));
    },
    onDelete(route) {
      dispatch(
        addMeta(
          routesActions.removeRouteStop(id),
          { route, index: route.stops.indexOf(id) },
        ),
      );
    },
  }),
  ({ route, ...stateProps }, { onDelete, ...dispatchProps }, ownProps) => ({
    ...ownProps,
    ...stateProps,
    ...dispatchProps,
    onDelete() {
      onDelete(route);
    },
  }),
)(RouteStopOptionsDummy);

const StopCard = ({
  id,
  name,
  students = [],
  isLoading = false,
  isShowing = false,
  onStudentSelected,
  isMapPristine = false,
}: StopCardPropTypes) => (
  isShowing
    ? (
      <Card
        className={
          `
            ${styles.stopCard}
            ${!isMapPristine ? styles.hidden : ''}
          `
        }
        isRound
      >
        <Popup
          id="editRouteStop"
          theme="main"
          transitionMs={600}
        >
          <RouteStopEditPopupContainer routeStopId={id} />
        </Popup>
        <CardHeader size="small">
          <CardHeaderTitleContainer>
            <CardHeaderTitle size="small" title={name} />
          </CardHeaderTitleContainer>
          <CardHeaderRightGroup>
            <RouteStopOptions id={id} />
          </CardHeaderRightGroup>
        </CardHeader>
        <CardContent clearPaddings isLimited>
          {
            isLoading
              ? <OmnisearchLoadingResults count={3} size="small" />
              : <RouteCardPassengers students={students} />
          }
        </CardContent>
        <CardFooter clearPaddings>
          <StudentSearch
            className={styles.footerTypeahead}
            onChange={onStudentSelected}
            placeholder={Search(i18n.t('labels.students', { count: 1 }), 1)}
          />
        </CardFooter>

      </Card>
    ) : null
);


export default connect(
  (state) => {
    const currentRouteStop = selectors.getCurrentRouteStop(state);
    const schoolId = (selectors.getProfileOfType(state, 'admin') || {}).school || -1;
    const isMapPristine = selectors.isMapPristine(state);
    if (typeof currentRouteStop !== 'undefined') {
      return {
        id: currentRouteStop.id,
        school: schoolId,
        currentRouteStopId: currentRouteStop.id,
        name: currentRouteStop.name,
        isLoading: selectors.isRouteStopFetchingStudents(state, currentRouteStop.id)
          || selectors.isRouteStopFetching(state, currentRouteStop.id),
        students: selectors.getRouteStopStudents(state, currentRouteStop.id),
        isShowing: true,
        isMapPristine,
      };
    }

    return {
      id: -1,
      name: '',
      isLoading: true,
      students: [],
      isShowing: false,
      isMapPristine,
    };
  },
  dispatch => ({
    onStudentSelected(student, currentRouteStopId) {
      dispatch(routesActions.addStudentToRouteStop(currentRouteStopId, student));
    },
  }),
  ({ currentRouteStopId, ...stateProps }, { onStudentSelected, ...dispatchProps }, ownProps) => ({
    ...ownProps,
    ...stateProps,
    ...dispatchProps,
    onStudentSelected(student) {
      if (typeof currentRouteStopId !== 'undefined') { onStudentSelected(student, currentRouteStopId); }
    },
  }),
)(StopCard);



// WEBPACK FOOTER //
// ./src/scripts/components/StopCard/index.jsx